/**
 *  Ignorar a segurança e a confiança do valor fornecido para ser HTML Seguro.
 *  Use apenas isso quando o HTML ligado for inseguro (por exemplo, contém tags <Script>) e o código deve ser executado.
 *  O desinfetante deixará o HTML seguro e intacto; portanto, na maioria das situações, esse método não deve ser usado.
 *  AVISO: Chamar esse método com dados de usuário não confiáveis expõe seu aplicativo aos riscos de segurança do XSS!
 */

import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'higienizaHTML',
})
export class HigienizaHTML implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) {}

  public transform(value: any): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
